import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PassService } from "./pass.service";
import { SharedServiceService } from "app/services/shared-service.service";
import { Store } from "@ngrx/store";
import { AppState } from "app/app.state";
import * as RouteStackAction from "app/store/actions/route-stack.action";
import { TimerComponent } from "@vendor/shared-component/timer/timer.component";
@Component({
  selector: "app-dynamic-pass",
  templateUrl: "./dynamic-pass.component.html",
  styleUrls: ["./dynamic-pass.component.scss"],
})
export class DynamicPassComponent implements OnChanges, OnInit {
  @Input() isLoading = false;
  @Input() buttonTitle: string;
  @Input() actionName: string;
  @Input() selectedCard: any;
  @Input() mobileNo: any;
  // for get pooya pass
  @Input() transactionType: string;
  @Input() cardUniqueId: string;
  @Input() amount: string;
  @Input() billType: string;
  @Input() requestUniqueId: string;
  @Output() submitPass = new EventEmitter();
  @Output() return = new EventEmitter();
  @Output() snackEvent = new EventEmitter();
  hasError = false;
  passObj = {
    pass: null,
    cvv2: null,
    reqSeq: 1,
  };
  sourceCardPassForm: FormGroup;
  sourceCardPassFormErrors: any;
  pooyaLoading = false;

  subscription: any;
  pooyaButtonText = "دریافت رمز دوم پویا";
  expiredDate = false;
  expireDateValue = "";
  disabledResend = false;
  showTimer = false;
  @ViewChild(TimerComponent) timer: TimerComponent;
  constructor(
    private formBuilder: FormBuilder,
    private passService: PassService,
    private sharedService: SharedServiceService,
    private store: Store<{ routeStack: AppState }>
  ) {
    this.sourceCardPassFormErrors = {
      sourcePass: {},
      cvv2: {},
    };
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.checkExpiredDate();
    localStorage.setItem("selectedCard", JSON.stringify(this.selectedCard));
  }

  ngOnInit(): void {
    this.sourceCardPassForm = this.formBuilder.group({
      sourcePass: ["", [Validators.required, Validators.minLength(5)]],
      cvv2: ["", [Validators.required, Validators.minLength(3)]],
    });
    this.sourceCardPassForm.valueChanges.subscribe(() => {
      this.onSourceCardPassFormChanged();
    });
    // this.sharedService.handleInputFocus();
    this.checkExpiredDate();
    localStorage.setItem("selectedCard", JSON.stringify(this.selectedCard));
  }

  triggerWaitingPaymentFlag() {
    this.store.dispatch(new RouteStackAction.ChangeWaitingPaymentStatus(true));
  }
  getDynamicPass() {
    this.pooyaLoading = true;
    this.disabledResend = true;
    const data = {
      amount: this.amount,
      cardUniqueId: this.cardUniqueId,
      transactionType: this.transactionType,
      requestUniqueId: this.requestUniqueId,
      billType: this.billType,
      mobileNo: this.mobileNo,
    };
    this.passService.requestDynamicPass(data).subscribe(
      (res) => {
        if (res.code === 0) {
          this.pooyaLoading = false;
          if (res.content.sent) {
            const snack = {
              msg: "درخواست شما به بانک ارسال شد",
              status: true,
            };
            this.snackEvent.emit(snack);
            this.pooyaButtonText = "ارسال شد";
          } else {
            const snack = {
              msg: res.content.message,
              status: res.content.sent,
            };
            this.snackEvent.emit(snack);
            this.disabledResend = false;
          }
        } else {
          this.pooyaLoading = false;
          this.disabledResend = false;
          const snack = {
            msg: res?.message ? res.message : "خطا در برقراری ارتباط با بانک",
            status: false,
          };
          this.snackEvent.emit(snack);
        }
      },
      (error) => {
        this.pooyaLoading = false;
        this.disabledResend = false;
        const snack = {
          msg: "خطا در برقراری ارتباط با بانک",
          status: false,
        };
        this.snackEvent.emit(snack);
      }
    );
  }

  submitedPass() {
    this.passObj.pass = this.sharedService.convertToEnglishNumber(
      this.passObj.pass
    );
    this.passObj.cvv2 = this.sharedService.convertToEnglishNumber(
      this.passObj.cvv2
    );

    if (JSON.parse(localStorage.getItem("paymentRequestSeq")) === null) {
      this.passObj.reqSeq = 1;
    } else {
      this.passObj.reqSeq =
        JSON.parse(localStorage.getItem("paymentRequestSeq")) + 1;
    }
    localStorage.setItem("paymentRequestSeq", String(this.passObj.reqSeq));
    this.submitPass.emit(this.passObj);
  }

  onSourceCardPassFormChanged() {
    for (const field in this.sourceCardPassFormErrors) {
      if (!this.sourceCardPassFormErrors.hasOwnProperty(field)) {
        continue;
      }
      // Clear previous errors
      this.sourceCardPassFormErrors[field] = {};

      // Get the control
      const control = this.sourceCardPassForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.sourceCardPassFormErrors[field] = control.errors;
      }
    }
  }

  returnAction() {
    this.return.emit();
  }

  checkExpiredDate() {
    const now = new Date().toLocaleDateString("fa").split("/");
    const currentYear = this.sharedService.convertToEnglishNumber(now[0]);
    const currentMonth = this.sharedService.convertToEnglishNumber(now[1]);
    const expDate = this.selectedCard.expDate;
    let year = expDate.substr(0, 2);
    const month = expDate.substr(2, 4);
    if (Number(year) > 9) {
      year = "13" + year;
    } else {
      year = "14" + year;
    }
    this.expireDateValue = year + "/" + month;
    this.expiredDate = false;
    if (Number(year) < Number(currentYear)) {
      this.expiredDate = true;
      return;
    }
    if (
      Number(year) === Number(currentYear) &&
      Number(month) < Number(currentMonth)
    ) {
      this.expiredDate = true;
    }
  }
}
